//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TheRadarMonthBadge",

  props: {
    styles: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    computedStyles() {
      return {
        ...this.styles
      };
    },
  },
}
